import React from "react";
import { observer } from "mobx-react";
import { TextFieldMask } from "../components";

import "../index.css";

function Field6_Edit_N(props) {
  const { row, updateRow, col, tableId, decimalScale, inputProps, isReadonly } =
    props;
  
  return (
    <TextFieldMask
      id={`enb-${col.key}`}
      defaultValue={row ? row[col.key] : null}
      disabled={col.isReadonly || isReadonly}
      className={`doc-table-value${
        col.isReadonly || isReadonly ? " disabled" : ""
      }`}
      //sx={col.eventProps.style}
      variant="outlined"
      label={col.inline ? col.Caption : null}
      onBlur={(prop) =>
        updateRow(row, col.tip, col.key, prop.target.value, tableId)
      }
      /*onChange={(prop) =>
        updateRow(row, col.tip, col.key, prop.target.value, tableId)
      }*/
      /*InputProps={{
        ...inputProps,
        inputComponent: NumericFormatCustom,
        inputProps: {
          decimalScale: decimalScale ?? 2,
          tip: col.tip,
          colkey: col.key,
        },
      }}*/
      isDecimal={true}
      /// ??? decimalScale={decimalScale ?? 2}
      size="small"
      inputProps={inputProps}
      tip={col.tip}
      colkey={col.key}
      {...props}
    />
  );
}
export default observer(Field6_Edit_N);
